import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconNormalScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.5 8C9.5 8.82843 8.82843 9.5 8 9.5H2V6.5H6.5V2H9.5V8Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 8C14.5 8.82843 15.1716 9.5 16 9.5H22V6.5H17.5V2H14.5V8Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.5 16C9.5 15.1716 8.82843 14.5 8 14.5H2V17.5H6.5V22H9.5V16Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 16C14.5 15.1716 15.1716 14.5 16 14.5H22V17.5H17.5V22H14.5V16Z",
			fill: "black"
		})
	]
});
export default SvgIconNormalScreen;
